var isNumber = require('../type/is-number');

var isOdd = function isOdd(num) {
  return isNumber(num) && num % 2 !== 0;
};

module.exports = isOdd;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/util/lib/math/is-odd.js
// module id = 299
// module chunks = 0 1 2